import { render, staticRenderFns } from "./ProfileFollowers.vue?vue&type=template&id=58ff50f0&scoped=true"
import script from "./ProfileFollowers.vue?vue&type=script&lang=js"
export * from "./ProfileFollowers.vue?vue&type=script&lang=js"
import style0 from "./ProfileFollowers.vue?vue&type=style&index=0&id=58ff50f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff50f0",
  null
  
)

export default component.exports